module.exports = {
          srcSet: __webpack_public_path__ + "4b13d3abc664f8aa4c560575d1c6967e-548.png"+" 548w",
          images:[ {path: __webpack_public_path__ + "4b13d3abc664f8aa4c560575d1c6967e-548.png",width: 548,height: 600}],
          src: __webpack_public_path__ + "4b13d3abc664f8aa4c560575d1c6967e-548.png",
          toString:function(){return __webpack_public_path__ + "4b13d3abc664f8aa4c560575d1c6967e-548.png"},
          
          width: 548,
          height: 600
        }